/*
gtag('event', <action>, {
  'event_category': <category>,
  'event_label': <label>,
  'value': <value>
});
eg:
gtag("event", "click", {
	"event_category": "social",
	"event_label": "twitter"
});
*/
export function addGAEvent() {
	let cm_gaID = (window as any).cm_gaID as string;

	if (!stringIsEmpty(cm_gaID)) {
		{
			// contact info's link.
			// Need to update in elementor:
			// The hyperlink change to:
			// mailto: info@oodles.com.hk
			// tel: +852 3898 6500
			// And set open in new window.
			// link component need to add class:
			// cm_contact_info
			const contactLinks = document.querySelectorAll(".cm_contact_info a");
			for (let index = 0; index < contactLinks.length; index++) {
				const link = contactLinks[index] as HTMLAnchorElement;

				if (link.href.startsWith("mailto")) {
					link.addEventListener("click", () =>
						sendGAEvent({
							category: "Conversion",
							action: "Conversion",
							label: "Email"
						})
					);
				}
				else if (link.href.startsWith("tel")) {
					link.addEventListener("click", () =>
						sendGAEvent({
							category: "Conversion",
							action: "Conversion",
							label: "Phone"
						})
					);
				}
			}
		}

		{
			// contact info's link in subdomain.
			const emailLinks = document.querySelectorAll(".cm-subdomain-email");
			for (let index = 0; index < emailLinks.length; index++) {
				const element = emailLinks[index];
				element.addEventListener("click", () =>
					sendGAEvent({
						category: "Conversion",
						action: "Conversion",
						label: "Email"
					})
				);
			}

			const phoneLinks = document.querySelectorAll(".cm-subdomain-phone");
			for (let index = 0; index < phoneLinks.length; index++) {
				const element = phoneLinks[index];
				element.addEventListener("click", () =>
					sendGAEvent({
						category: "Conversion",
						action: "Conversion",
						label: "Phone"
					})
				);
			}
		}

		{
			// contact form's send button in master site:
			const contactSendButton = document.querySelector('.contact-us-form button[type="submit"]');
			if (contactSendButton) {
				contactSendButton.addEventListener("click", () =>
					sendGAEvent({
						category: "Conversion",
						action: "Conversion",
						label: "Form"
					})
				);
			}
		}

		{
			// contact form's send button in sub domain:
			const contactSendButton = document.querySelector('.wpforms-container .wpforms-submit-container button[type="submit"]');
			if (contactSendButton) {
				contactSendButton.addEventListener("click", () =>
					sendGAEvent({
						category: "Conversion",
						action: "Conversion",
						label: "Form"
					})
				);
			}
		}

		{
			// Language buttons in master site.
			const languageButtons = document.querySelectorAll("li.wpml-ls-item a.menu-link");
			for (let index = 0; index < languageButtons.length; index++) {
				const button = languageButtons[index];

				const langSpan = button.querySelector(".wpml-ls-native");
				if (langSpan) {
					const lang = langSpan.getAttribute("lang");

					button.addEventListener("click", () =>
						sendGAEvent({
							category: "MainMenu",
							action: "Click language",
							label: lang
						})
					);
				}
			}
		}

		{
			// Language buttons in sub domain.
			const languageButtons = document.querySelectorAll(".custom-header-lang-switcher a");
			for (let index = 0; index < languageButtons.length; index++) {
				const button = languageButtons[index];

				const lang = button.getAttribute("lang");

				button.addEventListener("click", () =>
					sendGAEvent({
						category: "MainMenu",
						action: "Click language",
						label: lang
					})
				);
			}
		}
	}
}

export type UaEventOptions = {
	action: string;
	category: string;
	label?: string;
	value?: number;
};

function sendGAEvent(optionsOrName: UaEventOptions) {
	const gtag = (window as any).gtag;
	const eventData: any = {
		'event_category': optionsOrName.category,
	};
	if (optionsOrName.label !== undefined)
		eventData.event_label = optionsOrName.label;
	if (optionsOrName.value !== undefined)
		eventData.value = optionsOrName.value;

//////////////
	console.log(JSON.stringify(optionsOrName));
///////////

	gtag('event', optionsOrName.action, eventData);
}

function stringIsEmpty(input: string) {
	if (!input)
		return true;
	if (input.length == 0)
		return true;

	return false;
}